import React from "react";
import {BotCheckoutFormWrapper} from "../Stripe/BotCheckoutFormWrapper";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {StripeMessageStatus, WidgetChatMessage} from "../../../api/generated";
import {calcTimeDiff} from "../../chatbotUtil";
import {TextInMarkdown} from "./TextInMarkdown";

interface BotStripeMessageProps {
    index: number
    message: WidgetChatMessage
}

export const BotStripeMessage: React.FC<BotStripeMessageProps> = ({
                                                                      index,
                                                                      message
                                                                  }) => {
    return (
        <div key={index} className="mt-4 relative self-start w-full">
            <div className="flex flex-row justify-between">
                <div className="flex flex-col w-[85%]">
                    <div className="rounded-xl border-[1px] text-gray-900 py-3 px-4 bg-white">
                        {message.stripeMessageStatus != StripeMessageStatus.PaidConfirmed &&
                            <BotCheckoutFormWrapper message={message}/>}
                        <div className="text-gray-900 overflow-wrap-anywhere">
                            <TextInMarkdown text={message.message}/>
                        </div>
                    </div>
                    <div className="text-gray-500 ml-2 mt-1 text-[12px]"
                         suppressHydrationWarning>
                        {calcTimeDiff(message.timestamp)}
                    </div>
                </div>
            </div>
        </div>
    );
}
